import {inject} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivateFn, Router} from '@angular/router';
import {RouteName} from '@ew/enums';
import {RequiredParam} from './utils/required-param.enum';

/**
 * A guard that checks if a required URL parameter is present in the current route.
 *
 * @param {RequiredParam} paramName - The name of the required URL parameter.
 * @param {RouteName} redirectTo - The route to redirect to if the required URL parameter is not present.
 * @returns {CanActivateFn} A function that returns true if the required URL parameter is present, otherwise false.
 */
export function urlParamVerificationGuard(
  paramName: RequiredParam,
  redirectTo: RouteName,
): CanActivateFn {
  return (route: ActivatedRouteSnapshot) => {
    const router = inject(Router);

    const requiredUrlParam = route.queryParams[paramName];

    if (!requiredUrlParam) {
      router.navigateByUrl(redirectTo);
      return false;
    }

    return true;
  };
}
